'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tile = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _icons = require('constants/icons');

var _CmsHeading = require('components/CmsPage/modules/CmsHeading/CmsHeading');

var _CmsText = require('components/CmsPage/modules/CmsText/CmsText');

var _DocumentLevel = require('providers/DocumentLevel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_POSITIONS = ['top', 'left', 'left-center'];
var ICON_SRC_BY_NAME = (0, _extends3.default)({}, _icons.NUMBER_ICONS, _icons.CIRCLE_ICONS, _icons.TILE_ICONS);

var Tile = exports.Tile = function Tile(_ref) {
  var description = _ref.description,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      title = _ref.title;

  var src = ICON_SRC_BY_NAME[icon];
  var tileClassName = (0, _classnames2.default)((0, _defineProperty3.default)({
    Tile: true
  }, 'Tile--position-' + iconPosition, ICON_POSITIONS.includes(iconPosition)));

  return _react2.default.createElement(
    _DocumentLevel.NestDocumentLevel,
    null,
    _react2.default.createElement(
      'section',
      { className: tileClassName },
      src && _react2.default.createElement(_reactInlinesvg2.default, { className: 'Tile__icon', src: src }),
      _react2.default.createElement(
        'div',
        { className: 'Tile__content' },
        _react2.default.createElement(_CmsHeading.CmsHeading, { size: 'large', title: title }),
        _react2.default.createElement(_CmsText.CmsText, { content: description })
      )
    )
  );
};

Tile.defaultProps = {
  iconPosition: 'top'
};

Tile.propTypes = {
  description: _propTypes2.default.string,
  icon: _propTypes2.default.oneOf((0, _keys2.default)(ICON_SRC_BY_NAME)),
  iconPosition: _propTypes2.default.oneOf(ICON_POSITIONS),
  title: _propTypes2.default.string
};